module.exports = __webpack_public_path__ + "img/x19.814d93ed.jpg";